import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App/App";
import * as serviceWorker from "./serviceWorker";

// eslint-disable-next-line no-unused-vars
import $ from "jquery";
// eslint-disable-next-line no-unused-vars
import Popper from "popper.js";
import "bootstrap/dist/js/bootstrap.bundle.min";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

$(document).ready(function() {
  $("body").scrollspy({
    target: "#navbar",
    offset: 200
  });

  $(window).scroll(function() {
    if ($(document).scrollTop() > 64) {
      $("#navbar").addClass("shrink");
    } else {
      $("#navbar").removeClass("shrink");
    }
  });
  $("#navbar .nav-link").on("click", function() {
    let id = $(this).attr("href");
    console.log(id);
    document.querySelector(id).scrollIntoView();
    return false;
  });
});
